import { awardTypeToStr } from '../components/award-type';
import { type AwardFormSchema, type AwardMutationSchema } from '../schemas';

export function awardFormToUpdate({
  brand,
  client,
  award_type,
  award_month,
  award_year,
  gallery,
  ...rest
}: AwardFormSchema): AwardMutationSchema {
  return {
    ...rest,
    brand_id: brand?.id || null,
    client_id: client?.id || null,
    award_type: awardTypeToStr(award_type),
    award_month: award_month?.value ?? null,
    award_year: award_year?.value ? parseInt(award_year?.value) : null,
    gallery: (gallery || []).map((item) => item.id) || [],
  };
}
